import PageHero from "@/components/sections/PageHero";
import Services from "@/components/sections/Services";
import Booking from "@/components/sections/Booking";

export default function NettoyagePage() {
  return (
    <>
      <PageHero
        eyebrow="/ Nettoyage automobile"
        title="Detailing automobile"
        accent="à domicile"
        description="Choisissez la formule adaptée à votre véhicule. Tarifs précis selon votre catégorie, prestations transparentes."
      />
      <Services />
      <Booking />
    </>
  );
}
